import Translator from "./translator";

const defaultDefects = [
    "Brakes (Parking)",
    "Slow to release",
    "Weak or ineffective",
    "Will not release",
    "Brakes (Service)",
    "Air compressor not working",
    "Chatters, shudders, or vibrates",
    "Dragging",
    "Leaking air",
    "Leaking fluid",
    "Overheating or running hot",
    "Seized",
    "Warning light not working",
    "Warning light on",
    "Coupling Devices",
    "Fifth wheel cracked or damaged",
    "Emergency Equipment",
    "Fire extinguisher missing",
    "Fire extinguisher not charged",
    "Flags or flares missing",
    "Reflective triangles missing",
    "Spare bulbs or fuses missing",
    "Spare seal beam missing",
    "Horn",
    "Inoperable air horn",
    "Inoperable electric horn",
    "Lights and Reflectors",
    "Cracked or broken",
    "Improperly aimed (headlight)",
    "Inoperable 4-way flasher",
    "Inoperable brake light",
    "Inoperable headlight high beam",
    "Inoperable headlight low beam",
    "Inoperable interior light",
    "Inoperable left turn signal",
    "Inoperable right turn signal",
    "Missing",
    "Mirrors",
    "Broken or cracked",
    "Improperly adjusted",
    "Loose or insecurely mounted",
    "Other",
    "Steering",
    "Binds or grabs",
    "Drifts or pulls left",
    "Drifts or pulls right",
    "Fluid level improper",
    "Loose or excessive wheel play",
    "Tires",
    "Bulging or swelling",
    "Flat or leaking air",
    "Improperly inflated",
    "Insufficient tread",
    "Tread or sidewall separation",
    "Wheels and Rims",
    "Bent, cracked, or damaged",
    "Leaking seals",
    "Rusty or corroded",
    "Windshield Wipers",
    "Improper spraying",
    "Improper wiping",
    "Brakes",
    "Loose or malfunctioning connections",
    "Locking mechanism won't disengage",
    "Locking mechanism won't engage",
    "Parts loose or insecurely mounted",
    "Parts missing",
    "Pin cracked or damaged",
    "Pintle hook assembly cracked",
    "Pintle hook assembly damaged",
    "Safety chains cracked or damaged",
    "Doors",
    "Handle loose or missing",
    "Lock broken or inoperative",
    "Ties broken, loose, or missing",
    "Landing Gear",
    "Inoperative",
    "Inoperative 4-way flasher",
    "Inoperative brake light",
    "Inoperative interior light",
    "Inoperative left turn signal",
    "Inoperative right turn signal",
    "Air loss rate exceeds prescribed limit",
    "Audible air leak",
    "Pushrod stroke of any brake exceeds the adjustment limit",
    "Slow air pressure build-up rate",
    "Inoperative towing vehicle (tractor) protection system",
    "Low air warning system fails or system is activated",
    "Any cab or sleeper door fails to close securely",
    "Occupant compartment door fails to open",
    "Absence, failure, malfunction or deterioration of required cargo securement device or load covering",
    "Insecure cargo",
    "Insecure or improper load covering (e.g. wrong type or flapping in the wind)",
    "Coupler is insecure or movement exceeds prescribed limit",
    "Coupler or mounting has loose or missing{} fastener",
    "Coupling or locking mechanism is damaged or fails to lock",
    "Coupling or locking mechanism is damaged or fails to lock.",
    "Defective, incorrect or missing safety chain/cable",
    "Dangerous goods requirements not met",
    "Accelerator pedal, clutch, gauges, audible and visual indicators or instruments fail to function properly",
    "Seat is damaged or fails to remain in set position",
    "Seat belt or tether belt is insecure, missing or malfunctions",
    "Inoperative brake",
    "Inoperative breakaway device",
    "Loose or insecure wiring or electrical connection",
    "Emergency equipment is missing, damaged or defective",
    "Exhaust leak",
    "Damaged frame or cargo body.",
    "Visibility shifted, collapsing or sagging frame member(s)",
    "Dripping fuel leak",
    "Insecure fuel tank",
    "Missing fuel tank cap",
    "Serious damage or deterioration that is noticeable and may affect the vehicle's safe operation",
    "Required mirror or glass has broken or damaged attachments onto vehicle body",
    "Required mirror or window glass fails to provide the required view to the driver as a result of being cracked, broken, damaged, missing or maladjusted",
    "Defroster fails to provide unobstructed view through the windshield",
    "Vehicle has no operative horn",
    "Activated (other than ABS) warning device",
    "Brake boost or power assist is inoperative.",
    "Brake boost or power assist is inoperative",
    "Brake fluid leak",
    "Brake fluid level is below indicated minimum level",
    "Brake fluid reservoir is less than 1/4 full",
    "Brake pedal fade or insufficient brake pedal reserve",
    "Parking brake is inoperative",
    "Failure of a rearmost turn-indicator lamp",
    "Failure of both low-beam headlamps",
    "Failure of both rearmost brake lamps",
    "Failure of both rearmost tail lamps",
    "Required lamp does not function as intended",
    "Required reflector is missing or partially missing",
    "Steering wheel is insecure, or does not respond normally",
    "Steering wheel lash (free-play) exceeds required limit",
    "Steering wheel lash (free-play) is greater than normal",
    "Air leak in air suspension system",
    "Air leak in air suspension system.",
    "Broken spring leaf",
    "Broken spring leaf.",
    "Cracked or broken main spring leaf or more than one broken spring leaf",
    "Damaged (patched, cut, bruised, cracked to braid, mounted insecurely) or deflated air bag",
    "Loose U-bolt",
    "Part of spring leaf or suspension is missing, shifted out of place or in contact with another vehicle component",
    "Suspension fastener is loose, missing or broken",
    "Damaged tread or sidewall of tire",
    "Flat tire",
    "Tire has exposed cords in the tread or outer side wall area.",
    "Tire has exposed cords in the tread or outer side wall area",
    "Tire is in contact with another tire or any vehicle component other than mud-flap",
    "Tire is marked \"not for highway use\"",
    "Tire leaking (if leak can be felt or heard, tire is to be treated as flat)",
    "Tire tread depth is less than wear limit",
    "Damaged, cracked or broken wheel, rim or attaching part",
    "Evidence of imminent wheel, hub or bearing failure",
    "Hub oil below minimum level. (When fitted with sight glass)",
    "Leaking wheel seal",
    "Wheel has loose, missing or ineffective fastener",
    "Control or system malfunction",
    "Wiper blade damaged, missing or fails to adequately clear driver's field of vision",
    "Wiper or washer fails to adequately clear driver's field of vision in area swept by driver's side wiper",
    "Alarm fails to operate",
    "Equipment malfunctions",
    "Extendable lift, ramp or other passenger-loading device fails to retract",
    "Interlock system malfunctions",
    "Vehicle fails to return to normal level after \"kneeling\"",
    "Inoperative service, parking or emergency brake",
    "Alarm inoperative",
    "Door, window or hatch fails to open or close securely",
    "Required emergency exit fails to function as intended",
    "Accelerator sticking and engine fails to return to idle",
    "Leak that causes exhaust gas to enter the occupant compartment",
    "Damaged frame or body",
    "Insecure or missing body parts",
    "Insecure or missing compartment door",
    "Visibly shifted, cracked, collapsing or sagging frame member(s)",
    "Driver's view of the road is obstructed in the area swept by the windshield wipers",
    "Passenger safety or access lamp does not function",
    "Damaged steps or floor",
    "Insecure or damaged overhead luggage rack or compartment",
    "Malfunction or absence of required passenger or mobility device restraints",
    "Passenger seat is insecure",
    "Stanchion padding is damaged",
    "Cracked or broken main spring leaf or more than one broken spring leaf in any spring assembly",
    "Damaged ( patched, cut, bruised, cracked to braid, mounted insecurely.) or deflated air bag",
    "There is any indication of a brake adjustment problem",
    "Air Brake System",
    "Cab",
    "Cargo Securement",
    "Dangerous Goods",
    "Suspension System",
    "Coupler or mounting has loose or missing fastener",
    "Coupler or mounting has loose or missing fastener.",
    "Driver Controls",
    "Driver Seat",
    "Exhaust System",
    "Frame and Cargo Body",
    "Fuel System",
    "General",
    "Glass and Mirrors",
    "Heater/Defroster",
    "Hydraulic Brake System",
    "Electric Brake System",
    "Emergency Equipment & Safety Devices",
    "Control or system failure",
    "Lamps and Reflectors",
    "Wheels, Hubs and Fasteners",
    "Windshield Wiper/Washer",
    "Accessibility Devices",
    "Doors and Emergency Exits",
    "Exterior Body and Frame",
    "Passenger Compartment",
    // TODO: Remove duplicates with period at end
    "Low air warning system fails or system is activated.",
    "Inoperative service, parking or emergency brake.",
    "Inoperative brake.",
    "Loose or insecure wiring or electrical connection.",
    "Emergency equipment is missing, damaged or defective.",
    "Exhaust leak.",
    "Leak that causes exhaust gas to enter the occupant compartment.",
    "Door, window or hatch fails to open or close securely.",
    "Suspension fastener is loose, missing or broken.",
    "Hub oil below minimum level. (When fitted with sight glass).",
    "Control or system malfunction.",
    "Dangerous goods requirements not met.",
    "Missing fuel tank cap.",
    "Damaged steps or floor.",
    "Coupler is insecure or movement exceeds prescribed limit.",
    "Accelerator pedal, clutch, gauges, audible and visual indicators or instruments fail to function properly.",
    "Failure of a rearmost turn-indicator lamp.",
    "Extendable lift, ramp or other passenger-loading device fails to retract.",
    "Defective, incorrect or missing safety chain/cable.",
    "Insecure or damaged overhead luggage rack or compartment.",
    "Passenger seat is insecure.",
    "Stanchion padding is damaged."
];

export default class DefectListTranslation {

    private readonly translations: string[] = [];
    private readonly initialized;

    constructor(translator: Translator, language?) {
        this.initialized = translator.translate(defaultDefects, language).then(translations => {
            defaultDefects.forEach((defectName, index) => {
                let translatedDefectName = translations[index];
                if (translatedDefectName) {
                    this.translations[defectName] = translatedDefectName;
                }
            });
        });
    }

    ready(callback) {
        return this.initialized.then(callback);
    }

    translate(defectName) {
        return this.translations[defectName] || defectName;
    }
}